import { AppEnvironment } from '../constants/appEnvironment';
import { envVars } from './envVars';

export const axleEnvironment = envVars.axleEnvironment;

// export const isProduction = axleEnvironment === 'production';
// export const isDevelopment = axleEnvironment === 'development';
// export const isStaging = axleEnvironment === 'staging';
export const isLocal = axleEnvironment === AppEnvironment.LOCAL;
